import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { LoadingSpinner } from '../../components/LoadingSpinner';
import usePromotionQuery from '../../hooks/usePromotionQuery';
import { ContentCard } from '../../layout/ContentCard';
import PromotionConfigureCard from './PromotionConfigureCard';
import { PromotionForm } from './PromotionForm';

const PromotionFormPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const promotionId = id ? Number(id) : undefined;
  const promotionQuery = usePromotionQuery(promotionId);

  return (
    <>
      {promotionQuery.isPending && promotionId != null && <LoadingSpinner />}
      {(promotionId == null || promotionQuery.isSuccess) && (
        <ContentCard header={id == null ? t('promotions:form.header.create') : t('promotions:form.header.update')} mb="8">
          <PromotionForm promotion={promotionQuery.data ?? null} />
        </ContentCard>
      )}
      {promotionQuery.isSuccess && promotionId != null && <PromotionConfigureCard promotionId={promotionQuery.data.id} />}
    </>
  );
};

export default PromotionFormPage;
